module.exports = __webpack_public_path__ + "static/media/hero_bg.e73774c1.png";